import React from "react"

import Layout from "../components/layout/main"
import HomeBreadcrumb from "../components/home/homebreadcrumb"
import YoutubeTanitim from "../components/home/youtubetanitim"
import AnasayfaCarousel from "../components/global/carousel/anasayfacarousel"
import Seo from "../components/global/seo/seo.jsx"
const IndexPage = () => (
  <Layout>
    <Seo
      title="Erez Kaynak - Çelik Hasır Tel ve Paslanmaz Filtre İmalatçısı - Hızlı ve Kaliteli Hizmet"
      description="Paslanmaz, galvanize yada çelik telden, tel kalınlığı ve ebat, göz aralığı fark etmeksizin punta kaynaklı hasır tel (çesan) imalatı yapılır.Paslanmaz elek teli ve paslanmaz filtre imalatçısı"
      keywords="hasır tel,hasır tel fiyatları,hasır tel imalatı,paslanmaz hasır tel,hasır telleri,puntalı hasır tel,punta kaynaklı hasır tel,puntalı hasır tel fiyatları,hasır,tel,hasır tel imalatçısı,özel hasır tel,galvaniz hasır tel,hasır tel istanbul,tel hasır,kafes tel,tel hasır fiyatları,kafes tel fiyatları,hasır tel fiyatı,filtre imalatı,elek imalatı,paslanmaz filtre,paslanmaz elek"
    />
    <HomeBreadcrumb />
    <YoutubeTanitim />
    <AnasayfaCarousel />
  </Layout>
)

export default IndexPage
